import { getAllInventories } from "../../api/gold-inventory"

const state = () => ({
	tradeGoldInventories: [],
	gtmuGoldInventories: [],
	apiStatus: 'idle', // 'idle' | 'loading' | 'success' | 'error'
})

const getters = {
	getTradeGoldInventoriesByContractId: (state) => (contractId) => {
		return state.tradeGoldInventories[contractId] || []
	},
	getGtmuGoldInventoriesByContractId: (state) => (contractId) => {
		return state.gtmuGoldInventories[contractId] || []
	}
}

const actions = {
	async fetchAllInventories({ commit, state }, params) {
		if (state.apiStatus === 'loading') {
			return
		}

		commit('setApiStatus', 'loading')

		try {
			const response = await getAllInventories(params)
			if (response && response.data) {
				if (params.type === 'TRADE') {
					commit('setTradeGoldInventories', response.data)
				} else if (params.type === 'GTMU') {
					commit('setGtmuGoldInventories', response.data)
				}
			}

			commit('setApiStatus', 'success')
		} catch (error) {
			console.error('Error fetching gold inventories:', error)
		}
	}
}

const mutations = {
	setTradeGoldInventories(state, inventories) {
		state.tradeGoldInventories = inventories
	},

	setGtmuGoldInventories(state, inventories) {
		state.gtmuGoldInventories = inventories
	},

	setApiStatus(state, status) {
		state.apiStatus = status
	}
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}